import React, { createContext, useContext, useState } from "react";

const ModalContext = createContext<{
  open: boolean;
  toggle: () => void;
} | null>(null);

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);

  return (
    <ModalContext.Provider value={{ open, toggle }}>
      {children}
    </ModalContext.Provider>
  );
};
